<template>
  <quantity-steps
    :ref="(ref) => (quantitySteps = ref)"
    :item="item"
    :template="template"
    :requested-quantity="internalRequestedQuantity"
    :light="light"
    :auto-width="autoWidth"
    small
    @update-quantity="updateQuantity"
    @quantity-input="$emit('quantity-input')"
    @user-input="$emit('user-input', $event)"
    @value-rounded="(hint, dataTest2) => $emit('value-rounded', hint, dataTest2)"
  />
</template>

<script>
import QuantitySteps from '@/components/shop-modules/quantity-steps/QuantitySteps.vue';

export default {
  name: 'QuantityStepsUpdater',
  components: {
    QuantitySteps,
  },
  props: {
    item: {
      type: Object,
      default: null,
    },
    template: {
      type: String,
      default: '',
    },
    requestedQuantity: {
      type: Number,
      required: true,
    },
    autoWidth: {
      type: Boolean,
      default: false,
    },
    light: Boolean,
  },
  emits: ['quantity-input', 'update-quantity', 'user-input', 'value-rounded'],
  data() {
    return {
      internalRequestedQuantity: 0,
      quantitySteps: null,
    };
  },
  created() {
    this.internalRequestedQuantity = this.requestedQuantity;
  },
  methods: {
    getInputValue() {
      return this.quantitySteps ? this.quantitySteps.getInputValue() : null;
    },
    updateQuantity(value) {
      const newValue = parseInt(value, 10);
      this.$emit('quantity-input');
      this.$emit('update-quantity', newValue);
      this.internalRequestedQuantity = newValue;
    },
  },
};
</script>
